import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ApiActivityService {
  private activitySubject = new Subject<void>();
  activity$ = this.activitySubject.asObservable();

  notifyActivity() {
    this.activitySubject.next();
  }
}

